// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.8 2.51531C14.6382 2.05807 15.6828 2.25718 16.2941 2.99074L21 8.63779H3V8.40621L13.8 2.51531Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 17.3677H21V21.9977H3V17.3677Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 10.6406H3V15.2706H21V10.6406Z"}}]};

const SandwichFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sandwich-filled',
    ref,
    icon: element,
  },
));

SandwichFilledIcon.displayName = 'SandwichFilledIcon';

export default SandwichFilledIcon;
